<template>
  <v-list-item>
    <v-list-item-title>{{ title }}</v-list-item-title>
    <div class="input-container">
      <v-checkbox
        v-model="logOnly"
        label="Log Only"
        hint="Logs only – when checked, no decline will occur for this reason."
        persistent-hint
        :disabled="isLocked"
      />

      <template v-if="!logOnly">
        <slot />
      </template>
    </div>
  </v-list-item>
</template>

<script>
export default {
  name: 'ClarityRiskExposedConfigItem',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  computed: {
    logOnly: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  flex-direction: column;
  gap: 1.5em;
}

</style>
